module.exports = __webpack_public_path__ + "static/media/delivery.1eeb0967.svg";